import React from 'react';
import { FDStack } from '@facet-wealth/design';

// If value is an array instead of a single string, wrap the normal component in with this to make value a string with all the original array items .join()ed by a space
export const withValueArray = (Component) => ({ value, ...props }) => <Component {...props} value={value.join(' ')} />;

// If value is an array instead of a single string, add a component for each element of the string
// eslint-disable-next-line react/prop-types
export const withComponentArray = (Component, spacing = 1) => ({ value, ...props }) => (
  <FDStack direction={'column'} spacing={spacing}>
    {value?.map((v) => (
      <Component {...props} value={v} />
    ))}
  </FDStack>
);
